/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
export const symbol = /*#__PURE__*/Symbol.for("effect/PrimaryKey");
/**
 * @since 2.0.0
 * @category accessors
 */
export const value = self => self[symbol]();
//# sourceMappingURL=PrimaryKey.js.map